module.exports = __webpack_public_path__ + "static/media/Buddy-Mark.d263a21b.svg";